import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { Drawer } from '@/shared/components/drawer';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';
import { Button } from '@/shared/uikitV2/Button';
import { BtnClose } from '@/widgets/modals/components/BtnClose';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${COLORS.systemDark200};

  ${media.md}, ${breakpoints.sm} {
    padding: 16px;
  }
`;

export const Body = styled.div`
  background: url('/assets/widgets/modals/vfoChat/chatPattern.svg') ${COLORS.systemLight200};
  background-size: cover;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  ${media.md}, ${breakpoints.sm} {
    &.mobileHidden {
      display: none;
    }
  }
`;

export const Sidebar = styled.div`
  background: ${COLORS.white};
  width: 350px;
  min-width: 350px;
  height: 100%;
  overflow: hidden;
  padding: 16px;
  position: relative;

  ${media.md}, ${breakpoints.sm} {
    width: 100%;
    min-width: unset;
    background: ${COLORS.systemLight200};
    padding: 0;

    &.mobileHidden {
      display: none;
    }
  }
`;

export const BodyHeader = styled.div`
  margin-left: 24px;
  background: ${COLORS.white};
  border-radius: 0 0 24px 24px;
  height: 64px;
  padding: 12px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  ${media.md}, ${breakpoints.sm} {
    margin-left: 0;
    border-radius: 0 0 16px 16px;
    height: 72px;
    padding: 8px 16px;
    flex-direction: row-reverse;
    justify-content: space-between;
    text-align: center;
  }
`;

export const BtnCloseStyled = styled(BtnClose)`
  color: ${COLORS.systemDark300};

  ${media.md},
  ${breakpoints.sm} {
    display: none;
  }
`;

export const BackButton = styled(Button)`
  &&& {
    display: none;

    ${media.md}, ${breakpoints.sm} {
      display: flex;
      order: 2;
    }
  }
`;

export const ChatTitle = styled(Title)`
  ${media.md}, ${breakpoints.sm} {
    flex: 1;
    order: 1;
    text-align: center;
  }
`;

export const ButtonDesktop = styled(Button)`
  &&& {
    display: flex;
  }
`;

export const BodyHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-right: 16px;

  ${media.md}, ${breakpoints.sm} {
    padding-right: 0;
  }
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 24px;
  gap: 24px;
  height: 100%;

  ${media.md}, ${breakpoints.sm} {
    background: ${COLORS.white};
    height: 100%;
    padding: 20px 16px 16px;
    border-radius: 16px 16px 0 0;
  }
`;

export const ChatsWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  overflow: auto;
  padding-bottom: 72px;

  ${media.md} {
    padding-bottom: 128px;
  }

  ${media.sm} {
    padding-bottom: 0;
  }
`;

export const ChatsList = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  color: ${COLORS.systemDark200};
  font-size: 12px;
`;

export const ChatItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  color: ${COLORS.systemDark300};
  font-size: 14px;

  &.active {
    background: ${COLORS.colorSky17A};
  }

  &:hover {
    opacity: 0.75;
  }

  ${media.md}, ${breakpoints.sm} {
    &.active {
      background: none;
    }

    padding: 12px 0;
  }
`;

export const Spaced = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
  position: relative;
`;

export const DateText = styled.div`
  white-space: nowrap;
  font-size: 12px;
  color: ${COLORS.systemDark200};
`;

export const CaseTitle = styled.b`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CaseInfo = styled.div`
  display: flex;
  flex-direction: column;

  ${media.md}, ${breakpoints.sm} {
    flex: 1;
    margin-right: 40px;
  }
`;

export const ChatContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: auto;
  max-height: 100%;
  padding-top: 64px;
  width: 100%;
  margin-top: auto;
  margin-bottom: 120px;

  &.empty {
    margin: auto;
  }

  &.isReply {
    padding-bottom: 150px;
  }

  ${media.md}, ${breakpoints.sm} {
    margin-bottom: 72px;
    padding: 72px 0 80px;

    &.isReply {
      padding-bottom: 120px;
    }
  }
`;

export const ChatInputWrapper = styled.label`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 24px;
  right: 24px;
  left: 24px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.systemDark100};
  border-radius: 24px;
  padding: 16px;

  ${media.md}, ${breakpoints.sm} {
    padding: 6px 8px;
    border-radius: 16px;
    right: 16px;
    left: 16px;
    bottom: 16px;
    gap: 0;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  border: none;
  background: none;
  outline: none;
  font-size: 16px;
  resize: none;
  min-height: 24px;
  max-height: 200px;
  overflow-y: auto;
  align-self: center;
`;

export const TextareaWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const InfoWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${COLORS.systemLight200};
  padding: 16px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
`;

export const InfoWrapperText = styled.div`
  color: ${COLORS.systemDark200};
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
`;

export const Reply = styled.div`
  border-radius: 6px;
  height: 36px;
  display: flex;
  align-items: center;
  padding: 2px 16px 2px 8px;
  background: #f4f7fb;
  overflow: hidden;
  position: relative;
  font-size: 12px;
  justify-content: space-between;
  margin-bottom: 8px;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 2px;
    height: 100%;
    background: ${COLORS.systemSky200};
  }

  ${media.md}, ${breakpoints.sm} {
    padding: 6px 8px;
    width: 100%;
  }
`;

export const ReplyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  max-width: calc(100% - 16px);
`;

export const ReplyName = styled.b`
  color: ${COLORS.systemSky200};
  line-height: 16px;
  white-space: nowrap;
`;

export const ReplyClose = styled.div`
  color: ${COLORS.systemDark200};
  cursor: pointer;
`;

export const ReplyText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const ButtonAccent = styled(Button)`
  &&& {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    color: ${COLORS.white};
    border: none;
    background: ${COLORS.systemSky200};
    flex-shrink: 0;

    &:hover {
      background: ${COLORS.systemSky300};
    }

    &:disabled {
      background: ${COLORS.systemDark50A};
    }
  }
`;

export const EmptyCase = styled.div`
  background: ${COLORS.white};
  padding: 16px;
  border-radius: 24px;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  color: ${COLORS.systemDark200};
  width: 392px;
  text-align: center;
  max-width: 100%;
`;

export const EmptyCaseTitle = styled.b`
  color: ${COLORS.systemDark300};
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
`;

export const EmptyCaseText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 360px;
`;

export const MessageItem = styled.div`
  padding: 12px 24px;
  display: flex;
  gap: 10px;
  position: relative;
  width: 100%;

  &:hover {
    background: ${COLORS.colorVfoMessageHover};

    .actions {
      display: flex;
    }
  }

  ${media.md}, ${breakpoints.sm} {
    padding: 12px 16px;

    &:hover .actions {
      display: none;
    }
  }
`;

export const MessageActions = styled.div`
  position: absolute;
  right: 24px;
  top: -22px;
  display: flex;
  gap: 8px;
  display: none;

  ${media.md}, ${breakpoints.sm} {
    right: 16px;
  }
`;

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.white};
  padding: 10px 12px;
  border-radius: 16px;
  max-width: calc(100% - 64px);

  &.me {
    background: ${COLORS.colorVfoMyMessage};
  }

  ${media.md}, ${breakpoints.sm} {
    max-width: calc(100vw - 74px);
  }
`;

export const ButtonUserName = styled(Button)`
  &&& {
    width: fit-content;
    height: fit-content;
    padding: 0;

    ${media.md}, ${breakpoints.sm} {
      font-size: 12px;
    }
  }
`;

export const Timestamp = styled.div`
  align-self: flex-end;
  font-size: 12px;
  color: ${COLORS.systemDark200};
  line-height: 16px;
`;

export const NoChat = styled.div`
  color: ${COLORS.systemDark200};
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  max-width: 515px;
  text-align: center;
  margin: auto;
  height: 100%;
`;

export const NoChatTitle = styled.b`
  color: ${COLORS.systemDark300};
  font-size: 18px;
  line-height: 26px;
`;

export const NoChatButtons = styled.div`
  display: flex;
  gap: 24px;
  align-item: flex-end;
  width: 100%;
`;

export const NoChatButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  color: ${COLORS.systemDark100};
  flex: 1;
`;

export const SystemMessage = styled.div`
  color: ${COLORS.systemDark200};
  padding: 8px 0;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
`;

export const Attachment = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: 100%;
  cursor: pointer;

  &:hover {
    opacity: 0.75;
  }

  &.nonClickable {
    cursor: auto;

    &:hover {
      opacity: 1;
    }
  }
`;

export const FileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: ${COLORS.systemDark200};
  max-width: 100%;
  width: 100%;
`;

export const FileTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.systemDark200};
  border-radius: 4px;
  width: 28px;
  height: 36px;
  color: ${COLORS.white};
  position: relative;
  flex-shrink: 0;

  &.loading,
  &.deleted {
    background: ${COLORS.systemDark100};
  }

  &.deleted {
    color: ${COLORS.systemDark200};
  }
`;

export const FileTitle = styled.b`
  color: ${COLORS.systemDark300};
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 36px);
  min-width: 64px;

  &.fullWidth {
    max-width: 100%;
  }
`;

export const LastMessage = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.systemDark200};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ChatItemContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 52px);
  width: 100%;
`;

export const AvailableMembers = styled.div`
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${COLORS.systemDark50A};
  background: ${COLORS.white};
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
`;

export const AvailableMembersHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  color: ${COLORS.systemDark200};
`;

export const MemberList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
  max-height: 0;
  overflow: hidden;
  padding: 0 12px;
  transition:
    max-height 0.25s ease,
    padding 0.25s ease,
    margin 0.25s ease;

  &.active {
    margin-top: 12px;
    max-height: 240px;
    overflow: auto;
    padding: 12px;
  }
`;

export const IconRotate = styled(Icon)`
  transition: transform 0.25s ease;
  color: ${COLORS.systemDark300};

  &.active {
    transform: scale(1, -1);
  }
`;
